import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { multiPolygonSchema, polygonSchema } from "../geojson";
import { paginatedSchema } from "../pagination";

import { baseAssetSchema } from "./assetsBase";

export const parcelListItemSchema = baseAssetSchema.extend({
  geometry: polygonSchema.or(multiPolygonSchema),
  name: z.string(),
  external_id: z.string().nullable(),
});

export type ParcelListItem = z.infer<typeof parcelListItemSchema>;

export const parcelListSchema = paginatedSchema(parcelListItemSchema);
export type ParcelList = z.infer<typeof parcelListSchema>;

export const parcelSchema = parcelListItemSchema;
export type Parcel = z.infer<typeof parcelSchema>;

export function useParcels(params = {}) {
  const url = combineUrlAndParams("/api/v4/parcels/", params);
  return useParsedQuery<ParcelList>(
    ["lizard-api-v4", "parcels", url],
    () => fetchWithError(url),
    (json: unknown) => parcelListSchema.parse(json)
  );
}

export function useParcel(id: number) {
  return useParsedQuery<Parcel>(
    ["lizard-api-v4", "parcels", id],
    () => fetchWithError(`/api/v4/parcels/${id}/`),
    (json: unknown) => parcelSchema.parse(json)
  );
}

export function useMultipleParcels(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "parcels", id],
        fetchFunction: () => fetchWithError(`/api/v4/parcels/${id}/`),
        parseFunction: (json: unknown) => parcelSchema.parse(json),
      };
    })
  );
}
